import { SVGProps, Ref, forwardRef } from 'react';

export const CopyFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 9c0-7 1-8 8-8 5.461 0 7.27.609 7.802 4.2-1.68.005-3.132.07-4.339.297-1.272.24-2.447.69-3.361 1.605s-1.366 2.09-1.606 3.362C6.26 11.718 6.2 13.236 6.2 15q-.002 1.044.036 1.971C.826 16.768 0 15.363 0 9m16-2c-7 0-8 1-8 8s1 8 8 8 8-1 8-8-1-8-8-8"
            fill="currentColor"
        />
    </svg>
));
CopyFilledSize24Glyph.displayName = 'CopyFilledSize24Glyph';
